import { BASE } from '@arcxgame/contracts'
import ArcNumber from '@arcxgame/contracts/dist/src/utils/ArcNumber'
import { BigNumber } from 'ethers'
import { Saving } from 'src/services/GraphService'
import { quickWeiValuePow } from '@arcxmoney/arcx-core'

export function calculateEarnings(saving: Saving, balance: BigNumber) {
  const bnNow = BigNumber.from(Date.now()).div(1000)
  const secondsDiff = bnNow.sub(saving.indexLastUpdate)
  const additionalIndex = quickWeiValuePow(BASE.add(saving.savingsRate), secondsDiff)
  return ArcNumber.bigMul(balance, saving.savingsIndex).mul(additionalIndex).div(BASE)
}
